<template>
    <div class="hello">
        <div class="hello_banner">
            <div class="banner_title">海宁乡厨网</div>
        </div>
        <div class="main_box">
            <div class="main_cen" :style="windowWidth < 1441?'width: calc(100% - 120px);':'width: calc(1440px - 120px);'">
                <div class="main_title" v-for="item,index in mainList" :key="index">
                    <router-link class="main_text" :to="item.to" :style="mainStates==index?'font-weight: bold;':''">
                        {{ item.name }}
                    </router-link>
                </div>
                <a href="http://wxapi.hnshipin.com/login" target="_blank">
                    <div class="main_title">
                        <div class="main_text" :style="mainStates==4?'font-weight: bold;':''">
                            后台入口
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: ['mainStates'],
    data() {
        return {
            windowWidth: window.innerWidth,
            mainList: [{
                name: '首页',
                to: {
                    path:'/'
                }
            }, {
                name: '海宁乡厨',
                to: {
                    path:'/kitchen'
                }
            }, {
                name: '农村家宴中心',
                to: {
                    path:'/feast'
                }
            }
            // , {
            //     name: '量化等级评定',
            //     to: {
            //         path:'/grade'
            //     }
            // }
        ]
        };
    },
    watch: {
        windowWidth() {
            this.windowWidth = window.innerWidth;
            // this.fullClick();
        },
    },
    mounted() {
        const that = this
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
		window.addEventListener('resize', that.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        // mainClick() {
        //     window.location.href = "http://wxapi.hnshipin.com/login";
        // }
        // fullClick(){
		// 	if(this.windowWidth<1056){
        //         console.log(this.windowWidth);
		// 		window.location.reload();
		// 	}
		// },
    }
};
</script>

<style scoped lang="less">
.hello {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .hello_banner {
        width: 100%;
        height: 340px;
        display: flex;
        align-items: center;
        justify-content: center;
        background:
            linear-gradient(90deg, rgba(0, 74, 128, 0.82), rgba(4, 110, 185, 0.46)),
            url("../assets/home/bj.png") center/cover no-repeat;
    }

    .banner_title {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 64px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-shadow: 0 4px 18px rgba(0, 45, 82, 0.32);
    }

    .main_box {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #046EB9;

        .main_cen {
            height: 60px;
            display: flex;
            align-items: center;

            .main_title {
                height: 60px;
                margin-right: 80px;
            }

            .main_text {
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                white-space: nowrap;
                cursor: pointer;
            }
            .main_text:hover {
                font-weight: bold;
            }
        }
    }
}
</style>
